<template>
  <div class="row">
    <div class="col-12">
      <div class="card mb-4 glass-card animate-fade-in">
        <div class="card-header pb-0">
          <div class="d-flex flex-wrap gap-2">
            <button @click="reload()" :disabled="disabled" type="button" class="modern-btn modern-btn-primary btn-sm text-end">
              <i class="fas fa-sync-alt me-1"></i> <span class="d-none d-sm-inline">Обновить</span>
            </button>
            <div class="btn-group dropdown" role="group">
              <button id="btnGroupDrop1" type="button" class="modern-btn modern-btn-outline btn-sm dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                {{ offerId === 0 ? 'Сайт': `ID ${offerId}` }}
              </button>
              <ul class="dropdown-menu glass" aria-labelledby="btnGroupDrop1">
                <li><span @click="sortOffer(0)" class="dropdown-item" style="cursor: pointer">Все сайты</span></li>
                <li><span @click="sortOffer(1)" class="dropdown-item" style="cursor: pointer">сайт 1</span></li>
                <li><span @click="sortOffer(2)" class="dropdown-item" style="cursor: pointer">сайт 2</span></li>
                <li><span @click="sortOffer(3)" class="dropdown-item" style="cursor: pointer">сайт 3</span></li>
                <li><span @click="sortOffer(4)" class="dropdown-item" style="cursor: pointer">сайт 4</span></li>
                <li><span @click="sortOffer(5)" class="dropdown-item" style="cursor: pointer">сайт 5</span></li>
                <li><span @click="sortOffer(6)" class="dropdown-item" style="cursor: pointer">сайт 6</span></li>
              </ul>
            </div>
            <div v-if="userData.userUtm != null" class="btn-group dropdown" role="group">
              <button id="btnGroupDrop2" type="button" class="modern-btn modern-btn-outline btn-sm dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                {{ utm === `9999999999` ? `Метка`: utm }}
              </button>
              <ul class="dropdown-menu glass dropdown-menu-scrollable" aria-labelledby="btnGroupDrop2">
                <li><span @click="sortUtm('9999999999')" class="dropdown-item" style="cursor: pointer">Весь трафик</span></li>
                <li  v-for="(e, k) in userData.userUtm" :key="k"><span @click="sortUtm(k)" class="dropdown-item" style="cursor: pointer">{{ e }}</span></li>
              </ul>
            </div>
            <div v-if="disabled" class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
        <div class="card-body px-0 pt-0 pb-2">
          <!-- Desktop Table View -->
          <div class="table-responsive p-0 table-mobile-view">
            <table class="modern-table align-items-center mb-0">
              <thead>
                <tr>
                  <th class="text-center">Дата</th>
                  <th class="text-center">Хит/Хост/БОТ</th>
                  <th class="text-center">На оплату</th>
                  <th class="text-center">Заказы</th>
                  <th class="text-center">Оплачено</th>
                  <th class="text-center">EPC</th>
                  <th class="text-center">Заработано</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(el, key) in statistic" :key="key">
                  <td class="align-middle text-center">
                    <span :class="key === 0 ? 'bold text-gradient' : 'font-weight-bold'" class="text-xs">{{ el.invoiceDate }}</span>
                  </td>
                  <td class="align-middle text-center">
                    <span :class="key === 0 ? 'bold' : 'font-weight-bold'" class="text-xs">{{ el.hit }} / {{ el.host }} / {{ el.bot }}</span>
                  </td>
                  <td class="align-middle text-center">
                    <span :class="key === 0 ? 'bold' : 'font-weight-bold'" class="text-xs">{{ el.payin }}</span>
                  </td>
                  <td class="align-middle text-center">
                    <span :class="key === 0 ? 'bold' : 'font-weight-bold'" class="text-xs">{{ el.order }}</span>
                  </td>
                  <td class="align-middle text-center">
                    <span :class="key === 0 ? 'bold' : 'font-weight-bold'" class="text-xs">{{ el.successOrder }}</span>
                  </td>
                  <td class="align-middle text-center">
                    <span :class="key === 0 ? 'bold' : 'font-weight-bold'" class="text-xs" v-html="(el.userBalance > 0 ? ((el.userBalance / ((el.hit > 0 ? el.hit : 1)))) : 0).toFixed(2) + ' USD'"></span>
                  </td>
                  <td class="align-middle text-center">
                    <span :class="key === 0 ? 'bold text-gradient' : 'font-weight-bold'" class="text-xs">{{ el.userBalance }} USD</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <!-- Mobile Card View -->
          <div class="table-card-view">
            <div v-for="(el, key) in statistic" :key="key" class="table-card-item">
              <div class="table-card-row">
                <span class="table-card-label">Дата</span>
                <span class="table-card-value" :class="key === 0 ? 'text-gradient' : ''">{{ el.invoiceDate }}</span>
              </div>
              <div class="table-card-row">
                <span class="table-card-label">Хит/Хост/БОТ</span>
                <span class="table-card-value">{{ el.hit }} / {{ el.host }} / {{ el.bot }}</span>
              </div>
              <div class="table-card-row">
                <span class="table-card-label">На оплату</span>
                <span class="table-card-value">{{ el.payin }}</span>
              </div>
              <div class="table-card-row">
                <span class="table-card-label">Заказы</span>
                <span class="table-card-value">{{ el.order }}</span>
              </div>
              <div class="table-card-row">
                <span class="table-card-label">Оплачено</span>
                <span class="table-card-value">{{ el.successOrder }}</span>
              </div>
              <div class="table-card-row">
                <span class="table-card-label">EPC</span>
                <span class="table-card-value" v-html="(el.userBalance > 0 ? ((el.userBalance / ((el.hit > 0 ? el.hit : 1)))) : 0).toFixed(2) + ' USD'"></span>
              </div>
              <div class="table-card-row">
                <span class="table-card-label">Заработано</span>
                <span class="table-card-value text-gradient" :class="key === 0 ? 'text-gradient' : ''">{{ el.userBalance }} USD</span>
              </div>
            </div>
          </div>
        </div>
        <div class="card-body px-0 pt-0 pb-2">
          <nav aria-label="Page navigation example">
            <ul class="pagination justify-content-center">
              <li class="page-item" :class="{'disabled': page < 1}">
                <a class="page-link" @click="prevP()" style="cursor: pointer;" aria-label="Previous">
                  <i class="fa fa-angle-left"></i>
                  <span class="sr-only">Previous</span>
                </a>
              </li>
              <li class="page-item"><a class="page-link" style="cursor: pointer;">{{ page + 1 }}</a></li>
              <li class="page-item" :class="{'disabled': (page + 1) >= totalPage}">
                <a class="page-link" @click="nextP()" style="cursor: pointer;" aria-label="Next">
                  <i class="fa fa-angle-right"></i>
                  <span class="sr-only">Next</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../services/api.js'

export default {
  name: 'Statistic',
  data() {
    return {
      disabled: false,
      user: this.$store.getters.USER,
      statistic: this.$store.getters.USERSTATISTIC,
      userData: {},
      page: 0,
      totalPage: 0,
      size: 30,
      offerId: 0,
      utm: '9999999999',
      AUDIO: {
        CLICK: new Audio(require('@/assets/media/click.mp3'))
      },
    }
  },
  components: {
},
  created() {
    this.userStatistic()
    setTimeout(() => {
      this.userData = this.$store.getters.USERDATA
    }, 500)
  },
  mounted() {
  },
  watch: {
  },
  beforeDestroy() {
  },
  methods: {
    sortOffer (id) {
      this.offerId = id
      this.AUDIO.CLICK.play()
      this.userStatistic()
    },
    sortUtm (key) {
      this.utm = key
      this.AUDIO.CLICK.play()
      this.userStatistic()
    },
    prevP () {
      this.page--
      this.userStatistic()
    },
    nextP () {
      this.page++
      this.userStatistic()
    },
    reload () {
      this.page = 0
      this.userStatistic()
    },
    userStatistic () {
      this.disabled = true
      api.get(`/api/userstatistic/${this.user.id}/${this.page}/${this.size}/${this.offerId}/${this.utm}`).then((res) => {
        if (!res.data.error) {
          this.statistic = res.data.userStatistic
          this.totalPage = res.data.totalPage
          this.$store.commit('SET_USERSTATISTIC', this.statistic)
          setTimeout(() => { this.disabled = false }, 1000)
        }
        if (res.data.error && res.data.message === 'unlogin') {
          this.$store.commit('SET_USER', {auth: false, token: false})
          this.$router.push('/')
        }
      })
    }
  }
}
</script>

<style scoped>
/* Desktop view - show table, hide cards */
.table-mobile-view {
  display: block;
}

.table-card-view {
  display: none;
}

/* Mobile view - hide table, show cards */
@media (max-width: 991.98px) {
  .table-mobile-view {
    display: none !important;
  }
  
  .table-card-view {
    display: block !important;
  }
}

/* Card styles */
.table-card-view {
  padding: 0 15px;
}

.table-card-item {
  background: var(--modern-bg-card);
  border: 1px solid var(--modern-bg-tertiary);
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
  transition: all 0.2s ease;
}

.table-card-item:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

.table-card-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid var(--modern-bg-tertiary);
}

.table-card-row:last-child {
  border-bottom: none;
}

.table-card-label {
  font-size: 13px;
  color: var(--modern-text-secondary);
  font-weight: 500;
}

.table-card-value {
  font-size: 14px;
  color: var(--modern-text-primary);
  font-weight: 600;
  text-align: right;
}

.table-card-value.text-gradient {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Dark theme */
body.dark-mode .table-card-item {
  background: rgba(30, 41, 59, 0.8);
  border-color: rgba(255, 255, 255, 0.08);
}

body.dark-mode .table-card-row {
  border-color: rgba(255, 255, 255, 0.08);
}

body.dark-mode .table-card-label {
  color: #94a3b8;
}

body.dark-mode .table-card-value {
  color: #f1f5f9;
}

/* Dark theme card header */
body.dark-mode .card-header {
  background-color: rgba(30, 41, 59, 0.8) !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08) !important;
}

/* Dark theme table headers */
body.dark-mode .modern-table thead {
  background-color: rgba(30, 41, 59, 0.8);
}

body.dark-mode .modern-table thead th {
  background-color: rgba(30, 41, 59, 0.8) !important;
  border-color: rgba(255, 255, 255, 0.08) !important;
  color: #f1f5f9 !important;
}

body.dark-mode .modern-table tbody tr {
  border-color: rgba(255, 255, 255, 0.08);
}

body.dark-mode .modern-table tbody tr:hover {
  background-color: rgba(99, 102, 241, 0.05);
}

body.dark-mode .modern-table td {
  border-color: rgba(255, 255, 255, 0.08);
}

/* Dark theme pagination */
body.dark-mode .page-link {
  background-color: rgba(30, 41, 59, 0.8);
  border-color: rgba(255, 255, 255, 0.08);
  color: #f1f5f9;
}

body.dark-mode .page-item.disabled .page-link {
  background-color: rgba(30, 41, 59, 0.4);
  border-color: rgba(255, 255, 255, 0.08);
  color: #64748b;
}

body.dark-mode .page-link:hover {
  background-color: rgba(99, 102, 241, 0.2);
  border-color: rgba(99, 102, 241, 0.5);
  color: #f1f5f9;
}

/* Scrollable dropdown menu */
.dropdown-menu-scrollable {
  max-height: 400px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(99, 102, 241, 0.3) rgba(30, 41, 59, 0.5);
}

.dropdown-menu-scrollable::-webkit-scrollbar {
  width: 6px;
}

.dropdown-menu-scrollable::-webkit-scrollbar-track {
  background: rgba(30, 41, 59, 0.5);
  border-radius: 3px;
}

.dropdown-menu-scrollable::-webkit-scrollbar-thumb {
  background: rgba(99, 102, 241, 0.3);
  border-radius: 3px;
}

.dropdown-menu-scrollable::-webkit-scrollbar-thumb:hover {
  background: rgba(99, 102, 241, 0.6);
}

/* Dark theme scrollable dropdown */
body.dark-mode .dropdown-menu-scrollable::-webkit-scrollbar-track {
  background: rgba(15, 23, 42, 0.5);
}

body.dark-mode .dropdown-menu-scrollable::-webkit-scrollbar-thumb {
  background: rgba(99, 102, 241, 0.3);
}

body.dark-mode .dropdown-menu-scrollable::-webkit-scrollbar-thumb:hover {
  background: rgba(99, 102, 241, 0.6);
}
</style>
